App.addModule(function(app) {

    app.on('loaded', () => {
        
        var initProductCarousel = function() {
	        
	        var container = $(this);
	        var slider = container.find('.slider');
	        
	        if (!slider.length || slider.hasClass('slick-initialized')) {
		        return;
	        }
	        
	        var settings = {
		        dots:			true,
            	draggable:		false,
		        appendDots:		container,
		        infinite:		false,
		        slidesToShow:	3,
		        slidesToScroll: 3,
		        responsive: [{
                	breakpoint: 768,
                	settings: {
                		slidesToShow: 2,
                		slidesToScroll: 2
                	}
		        }]
          	};
	        
	        var slides = slider.data('carousel-show-slides');
	        
	        if (slides) {
		        settings.slidesToShow = parseInt(slides);
		        settings.slidesToScroll = parseInt(slides);
	        }
	                		
	        slider.slick(settings);
        };

        var initProductMediaCarousel = function() {
	        
	        var container = $(this);
	        var slider = container.find('.slider');
	        
	        if (!slider.length || slider.hasClass('slick-initialized')) {
		        return;
	        }
	        
	        var settings = {
		        arrows:		false,
		        dots:		false,
            	draggable:	false,
		        appendDots:	container
          	}
	        
	        slider.slick(settings);
	        
	        container.find('.more-views a').each(function(i, e) {
		        
		        $(this).click(function(e) {
			        e.preventDefault();
			        slider.slick('slickGoTo', i);
		        });
	        });
        };

        var initCmsCarousel = function() {
	        
	        var container = $(this);
	        var slider = container.find('.slider');
	        
	        if (!slider.length || slider.hasClass('slick-initialized')) {
		        return;
	        }
	        
	        var settings = {
		        dots:		true,
                draggable:	false,
		        appendDots:	container,
		        adaptiveHeight: true
          	};
	                		
	        var speed = slider.data('carousel-autoplay-speed');
	        
	        if (speed) {
		        settings.autoplay = true;
		        settings.autoplaySpeed = parseInt(speed);
	        }
	        
	        slider.slick(settings);
        }

        $('.slider')
            .on('init', function() {
	            $(this).find('.slick-current').trigger('show.mia.slider');
	            $(this).find('.slick-slide').show();
            })
            .on('beforeChange', function(event, slick, cur, next) {
	            $(this).find('[data-slick-index="'+next+'"]').trigger('show.mia.slider');
            })
            .on('afterChange', function(event, slick, cur) {
	            $(this).find('[data-slick-index="'+cur+'"]').trigger('shown.mia.slider');
            });

        $('.catalog-product-view').on('shown.bs.collapse shown.bs.modal', function(event) {
            $(event.target).find('.product-carousel').each(initProductCarousel);
            $(event.target).find('.product-media-carousel').each(initProductMediaCarousel);
            $(event.target).find('.cms-carousel').each(initCmsCarousel);
        });

        $('.catalog-product-view').on('click', '[data-toggle="modal"]', function() {
            
            var e = $(this);
            
            var target = e.data('target') || e.attr('href');
            
            if (!target || target !== '#product-gallery-modal') {
	            return;
            }
            
            var index = e.data('gallery-index');
            
            if (index) {
	            index = parseInt(index)-1;
            }
            else {
	            
	            index = e.parents('.slick-slide').data('slick-index');
	            
	            if (index === undefined) {
		            return;
	            }
            }
            
            var slider = $(target).find('.slider');
            
            if (!slider.length) {
	            return;
            }
            
            if (slider.hasClass('slick-initialized')) {
	            slider.slick('slickGoTo', index);
            }
            else {
	            setTimeout(function() {
		            slider.slick('slickGoTo', index);
	            }, 500);
            }
        });

        $('.product-carousel').filter(':visible').each(initProductCarousel);
        $('.product-media-carousel').filter(':visible').each(initProductMediaCarousel);
        $('.cms-carousel').filter(':visible').each(initCmsCarousel);
    })
})
